import { OrderDocument } from '../../domain/entities/order-document.entity';
import { OrderDocumentType, OrderDocumentTypeLabel } from '../../domain/value-objects/order-document-type.vo';

export interface OrderDocumentApiResponse {
  id: string;
  orderId: string;
  filename: string;
  filePath: string;
  extension: string;
  size: number;
  documentType: number;
  createdAt: string;
}

export interface OrderDocumentListPagedApiResponse {
  items: OrderDocumentApiResponse[];
  pageNumber: number;
  pageSize: number;
  totalPages: number;
  totalItemsCount: number;
}

export class OrderDocumentMapper {
  static toDomain(raw: OrderDocumentApiResponse): OrderDocument {
    return {
      id: raw.id,
      orderId: raw.orderId,
      filename: raw.filename,
      filePath: raw.filePath,
      extension: raw.extension,
      size: raw.size,
      documentType: raw.documentType as OrderDocumentType,
      createdAt: new Date(raw.createdAt),
    };
  }

  static toDomainList(rawList: OrderDocumentApiResponse[]): OrderDocument[] {
    return rawList.map((raw) => this.toDomain(raw));
  }

  static toDocumentTypeLabel(type: OrderDocumentType): string {
    return OrderDocumentTypeLabel[type] ?? String(type);
  }

  static formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 B';
    if (bytes < 1024) return `${bytes.toFixed(2)} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(2)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
  }
}
